"use strict";function status$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.status$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="device.geolocation.status";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"3.4.8"},_a[ddSdk_1.ENV_ENUM.android]={vs:"3.4.8"},_a)),exports.status$=status$,exports.default=status$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/device/geolocation/status.js
// module id = 1060
// module chunks = 106